<template>
  <v-card>
    <FufuHeader>
      カウンセリングシート
    </FufuHeader>
    <v-card-text>
      <v-layout justify-center>
        本日は、ご来店誠にありがとうございます。
      </v-layout>
      <v-layout justify-center>
        ヘアカラー専門店 fufu は、アルカリカラーによる均一カラーの専門店です。
      </v-layout>
    </v-card-text>

    <NoticeCheck
      :patch-test.sync="form.patchTest"
      :notice-checks.sync="form.noticeChecks"
    />

    <v-card-text>
      <v-layout justify-center class="primary--text my-5">
        <b
          >上記注意事項に同意いただけましたら、お手数ですが下記問診票にお答えください。</b
        >
      </v-layout>
    </v-card-text>

    <v-card-text>
      <QuestionText required>
        ご年齢を下記からお選びください。
      </QuestionText>
      <v-layout class="px-3" wrap>
        <v-flex v-for="g in generations" :key="g" class="text-center">
          <v-checkbox
            v-model="form.age"
            :value="g"
            :label="g"
            hide-details
            color="primary"
            on-icon="mdi-check-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
          />
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-text>
      <QuestionText required>
        性別を下記からお選びください。
      </QuestionText>
      <v-layout class="px-3">
        <v-flex v-for="g in ['女性', '男性']" :key="g" class="text-center">
          <v-checkbox
            v-model="form.gender"
            :value="g"
            :label="g"
            hide-details
            color="primary"
            on-icon="mdi-check-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
          />
        </v-flex>
      </v-layout>
    </v-card-text>

    <CounselingQuestion
      v-for="q in questions.filter(x => x.isActive)"
      :key="q.id"
      :question="q"
      :value="getQuestionAnswer(q.id)"
      @input="setQuestionAnswer(q.id, $event)"
    />

    <v-card-text>
      <QuestionText>
        お客さま情報をご記入ください。
      </QuestionText>
      <div class="px-3">
        <!-- <v-layout>
          <v-flex class="pr-1">
            <v-text-field
              v-model="form.familyName"
              label="性"
              :error-messages="errors.familyName"
            >
              <span slot="label">
                <RequiredMark />
                姓
              </span>
            </v-text-field>
          </v-flex>
          <v-flex class="pl-1">
            <v-text-field
              v-model="form.givenName"
              label="名"
              :error-messages="errors.givenName"
            >
              <span slot="label">
                <RequiredMark />
                名
              </span>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="pr-1">
            <v-text-field
              v-model="form.familyNameKana"
              :error-messages="errors.familyNameKana"
            >
              <span slot="label">
                <RequiredMark />
                せい
              </span>
            </v-text-field>
          </v-flex>
          <v-flex class="pl-1">
            <v-text-field
              v-model="form.givenNameKana"
              :error-messages="errors.givenNameKana"
            >
              <span slot="label">
                <RequiredMark />
                めい
              </span>
            </v-text-field>
          </v-flex>
        </v-layout> -->

        <v-layout>
          <v-flex>
            <v-text-field
              v-model="form.postcode"
              v-mask="'###-####'"
              label="郵便番号"
              autocomplete="postal-code"
              type="tel"
              pattern="\d{3}-\d{4}"
              :error-messages="errors.postcode"
            >
              <span slot="label">
                <RequiredMark />
                郵便番号
              </span>
              <template v-slot:append>
                <PostcodeSearch
                  :postcode="form.postcode"
                  @result="onSearchPostcodeResult"
                />
              </template>
            </v-text-field>
          </v-flex>
          <v-flex />
        </v-layout>
        <v-text-field
          v-model="form.prefecture"
          label="都道府県"
          :error-messages="errors.prefecture"
        >
          <span slot="label">
            <RequiredMark />
            都道府県
          </span>
        </v-text-field>
        <v-text-field
          v-model="form.city"
          label="市区町村"
          :error-messages="errors.city"
        >
          <span slot="label">
            <RequiredMark />
            市区町村
          </span>
        </v-text-field>
        <v-text-field
          v-model="form.town"
          label="町名"
          :error-messages="errors.address"
        >
          <span slot="label">
            <RequiredMark />
            町名
          </span>
        </v-text-field>
        <v-text-field
          v-model="form.addressNumber"
          label="番地"
          :error-messages="errors.address"
        >
          <span slot="label">
            <RequiredMark />
            番地
          </span>
        </v-text-field>
        <v-text-field
          v-model="form.building"
          label="ビル名等"
          :error-messages="errors.building"
        />
        <!-- <v-text-field
          v-model="form.phoneNumber"
          v-mask="'###-####-####'"
          label="携帯電話番号"
          required
          type="tel"
          :error-messages="errors.phoneNumber"
        >
          <span slot="label">
            <RequiredMark />
            電話番号（携帯電話）
          </span>
        </v-text-field> -->
        <BirthdaySelect
          v-model="form.birthday"
          :error-messages="errors.birthday"
        />
        <!-- <v-text-field
          v-model="form.email"
          label="メールアドレス"
          :error-messages="errors.email"
        >
          <span slot="label">
            <RequiredMark />
            メールアドレス
          </span>
        </v-text-field> -->
        <v-checkbox
          v-model="form.receivesInfo"
          label="fufuからのクーポン情報やお知らせを受け取る"
          :error-messages="errors.receivesInfo"
        />
      </div>
      <v-alert v-if="errors.counselingAnswers" type="error" outlined>
        必須項目の入力が完了していません。
      </v-alert>
      <v-layout>
        <v-flex xs12 class="pt-5">
          <v-btn
            :disabled="!form.noticeChecks || form.patchTest === null"
            color="primary"
            x-large
            block
            @click="confirm"
          >
            <span class="subtitle-1">
              <b>確認する</b>
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <AppVersion />
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '@/store'

import FufuHeader from '@/components/FufuHeader'
import NoticeCheck from '@/components/NoticeCheck'
import CounselingQuestion from '@/components/CounselingQuestion'
import QuestionText from '@/components/QuestionText'
import RequiredMark from '@/components/RequiredMark'
import PostcodeSearch from '@/components/PostcodeSearch'
import AppVersion from '@/components/AppVersion'
import BirthdaySelect from '@/components/BirthdaySelect'

export default {
  name: 'MainView',
  components: {
    AppVersion,
    FufuHeader,
    NoticeCheck,
    CounselingQuestion,
    QuestionText,
    RequiredMark,
    PostcodeSearch,
    BirthdaySelect,
  },
  data: () => ({
    form: {
      noticeChecks: false,
      patchTest: null,
      age: '',
      birthday: '',
      gender: '',
      familyName: '',
      givenName: '',
      familyNameKana: '',
      givenNameKana: '',
      postcode: '',
      prefecture: '',
      city: '',
      town: '',
      addressNumber: '',
      building: '',
      copyFromUser: true,
      // phoneNumber: '',
      email: '',
      receivesInfo: true,
      counselingAnswers: [],
    },
    errors: {},
    postcodeAddresses: [],
  }),
  computed: {
    ...mapGetters(['questions']),
    generations() {
      return ['10代', '20代', '30代', '40代', '50代', '60代以上']
    },
  },
  created() {
    // this.fetchQuestions()
    let user = this.$store.state.user
    let form = this.form
    form.familyName = user.familyName
    form.familyNameKana = user.familyNameKana
    form.givenName = user.firstName
    form.givenNameKana = user.firstNameKana
    // form.phoneNumber = user.phoneNumber
    form.email = user.email
    form.shop = user.customerShop || '26c0c3a4-21c8-4667-b6b5-674786112e93'
    // if (!form.shop) this.$router.replace({ name: 'error' })
  },
  methods: {
    ...mapActions(['fetchQuestions']),
    getQuestionAnswer(id) {
      return this.form.counselingAnswers.filter(a => a.question === id)
    },
    setQuestionAnswer(id, values) {
      console.log('set Ans', id, 'len', values.length)
      this.form.counselingAnswers = this.form.counselingAnswers
        .filter(a => a.question !== id)
        .concat(values)
    },
    onSearchPostcodeResult(result) {
      let { pref, city, town } = result
      let form = this.form
      form.prefecture = pref
      form.city = city
      form.town = town
    },
    // hiraToKana(str) {
    //   return str.replace(/[\u3041-\u3096]/g, match => {
    //     var chr = match.charCodeAt(0) + 0x60
    //     return String.fromCharCode(chr)
    //   })
    // },
    // cleanName() {
    //   this.form.givenNameKana = this.hiraToKana(this.form.givenNameKana)
    //   this.form.familyNameKana = this.hiraToKana(this.form.familyNameKana)
    // },
    async confirm() {
      // this.cleanName()

      try {
        this.errors = {}
        let data = Object.assign(
          {
            enforceMobilePhoneNumber: false, // 11桁の番号強制（スマホ版のみ）
            emailRequired: false, // emailを必須化（スマホ版のみ）
          },
          this.form
        )
        if (data.email === '@@') {
          // NOTE: emailを不要にする隠しコマンド
          data.email = ''
          data.emailRequired = false
        }

        let { town, addressNumber } = this.form
        if (town && addressNumber) {
          data.address = town + addressNumber
        } else {
          data.address = ''
        }
        await this.$api.customers(this.$store.getters.customerId).validate(data)
        this.$router.replace({
          name: 'confirm',
          query: { form: JSON.stringify(data) },
        })
      } catch (err) {
        console.error(err)
        if (err.status === 400) {
          this.errors = err.response.data
        } else {
          this.$toast.error('サーバとの通信に失敗しました。')
          throw err
        }
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let form = null
      if (to.query.form) form = Object.assign({}, JSON.parse(to.query.form))

      await store.dispatch('fetchQuestions')
      next(vm => {
        if (form)
          Object.keys(vm.form).forEach(k => {
            vm.form[k] = form[k]
          })
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>

<style lang="scss" scoped>
.question {
  background-color: #f5f5f5;
  padding: 8px;
  color: black;
  font-size: 1rem;
}
</style>
